module.exports = __webpack_public_path__ + "10cdac97700802ef9c8b3fcfaaa97f56.svg";